export { default as ErrorComponent } from "./ErrorComponent";
